// WP-7.5 (ST-D): tracks `navigator.onLine`, updated live via the `online`/`offline` window
// events — the signal the OfflineBanner (and, later, any other UI that wants to know) reads to
// tell the owner they may be looking at cached data rather than a fresh read.
import { useEffect, useState } from 'react';

export function useOnlineStatus(): boolean {
  const [online, setOnline] = useState(() => navigator.onLine);

  useEffect(() => {
    const goOnline = (): void => {
      setOnline(true);
    };
    const goOffline = (): void => {
      setOnline(false);
    };
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  return online;
}
